export const getFileExtension = (filename: string): string => {
  return filename.split('.').pop()?.toUpperCase() || '';
};

export const getTypeColor = (type: string) => {
  const colors: { [key: string]: { bg: string; text: string } } = {
    'PDF': { bg: '#fee2e2', text: '#b91c1c' },
    'Video': { bg: '#dbeafe', text: '#1e40af' },
    'Presentation': { bg: '#f3e8ff', text: '#7c3aed' },
    'Spreadsheet': { bg: '#dcfce7', text: '#166534' },
    'Image': { bg: '#fef3c7', text: '#d97706' },
    'Audio': { bg: '#fce7f3', text: '#be185d' }
  };
  return colors[type] || { bg: '#f3f4f6', text: '#374151' };
};

export const extractResourceTitle = (filename: string): string => {
  const match = filename.match(/General Resources\/(.*).pdf/);
  return match ? match[1] : "Unknown resource";
};